<template>
  <div>
    <h1>{{article.title}}</h1>
    <div class="article-body article-content" v-html="article.body" data-external="articles"></div>
  </div>
</template>

<script>
import { getSpecificArticleFromStore, replaceMaHcLoginSupportContent } from '@/utils/common';
export default {
  props: ['articleIdProp'],
  data() {
    return {
      articleId: ''
    };
  },
  created() {
    if (!this.articleIdProp) {
      this.fetchIdFromHash();
      return;
    }
    this.articleId = this.articleIdProp;
  },
  updated() {
    replaceMaHcLoginSupportContent(this.articleId);
  },
  methods: {
    fetchIdFromHash() {
      let hash = this.$route.hash;
      let hashSplit = this.$route.hash.split('#');

      if (!hash || hashSplit.length <= 0) {
        this.$router.push('home');
      }
      this.articleId = hashSplit[1].split('-')[0];
    }
  },
  computed: {
    article() {
      return getSpecificArticleFromStore(this.articleId) || '';
    }
  },
  watch: {
    '$route.hash'() {
      this.fetchIdFromHash();
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/lsweepshc-design.scss';

div[data-external] p {
  font-size: 14px;
}
</style>

<style>
div.article-content[data-external] p {
  font-size: 14px;
}
div.article-content[data-external] a[data-link] {
  font-size: 24px;
}
</style>
